import React from 'react'
import Button from '../../components/atoms/Button';
import InformationText from '../../components/molecules/InformationText';
import ModalSuccess from './ModalSuccess';

export default ({
    show, title, content, icon, actYes, actNo, actClose, errMsg, placeholder, 
    onChange, value, loading, success, titleSuccess, contentSuccess, closeSuccess
}) => {
    return (
        <div className={`kc-modal ${!show && 'kc-modal-hiden'}`}>
            {
                success ? (
                    <ModalSuccess titleSuccess = {titleSuccess} contentSuccess = {contentSuccess} closeSuccess = {closeSuccess}/>
                ) : (
                    <div className='kc-modal-dialog'>
                        <button type="button" className="kc-modal-close" onClick={actClose}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        
                        <div className='kc-modal-content'>
                            <img className='icon' src={icon} alt='' />

                            <h1>{title}</h1>
                            <p className='resize-margin-p'>{content}</p>
                            <textarea className="form-control text-textarea" rows="3" placeholder={placeholder} value={value} onChange={(e) => onChange(e.target.value)} />
                            {
                                errMsg && (
                                    <InformationText type={'error'} value={errMsg} />
                                )
                            }
                            <div className='kc-modal-button'>
                                {actYes !== null && <Button type='button' loading={loading} title={actYes.title} color="yellow" width="big-rounded" onClick={actYes.action} />}
                                {actNo !== null && <Button type='button' loading={loading} title={actNo.title} color="outline" width="big-rounded" onClick={actNo.action} />}
                            </div>
                        </div>
                    </div>
                )
            }

        </div>
    )
}